/** Number formatting helpers (presentation layer only). */

export function formatNumber(
  value: number | null | undefined,
  significantFigures = 4,
  locale = 'en-US',
): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  if (!Number.isFinite(value)) return '∞';
  if (value === 0) return '0';
  const abs = Math.abs(value);
  if (abs < 0.001 || abs >= 1e6) {
    return value.toExponential(significantFigures - 1);
  }
  return new Intl.NumberFormat(locale, {
    maximumSignificantDigits: significantFigures,
    minimumSignificantDigits: Math.min(significantFigures, 3),
  }).format(value);
}

export function formatPercent(
  value: number | null | undefined,
  significantFigures = 4,
): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return `${formatNumber(value, significantFigures)}%`;
}

/** Render a PK row as a single copy-friendly string (F-074). */
export function formatPkRow(
  label: string,
  pk: {
    cmax: number;
    tmax: number;
    halfLife: number | null;
    clOverF: number | null;
    vzOverF: number | null;
  },
): string {
  return `${label}: Cmax=${pk.cmax}, Tmax=${pk.tmax}, t½=${pk.halfLife ?? '—'}, CL/F=${pk.clOverF ?? '—'}, Vz/F=${pk.vzOverF ?? '—'}`;
}
